'use client';
import { useRouter } from 'next/navigation';
import Image from 'next/image';
import { createCompleteAddress, joinPhoneNumbers } from '@utils';
import Highlighter from 'react-highlight-words';
import CenterIcon from '@images/center-icon.svg';
import CallIcon from '@images/map-search-call-icon.svg';
import EmailIcon from '@images/map-search-email-icon.svg';
import LocationIcon from '@images/map-search-location-icon.svg';

const CenterListItem = ({ center, search = '' }) => {
  const router = useRouter();
  const goFindCourse = () => {
    router.push(
      `${process.env.NEXT_PUBLIC_AUTH_APP_URL}/us-en/centers/courses/${center.sfid}`
    );
  };
  const phoneNumber = joinPhoneNumbers(center.phone1, center.phone2);
  const state = center?.state ?? center?.stateProvince ?? '';
  const zipCode = center?.postalCode ?? center?.postalOrZipCode ?? '';
  return (
    <div className="search-list-item">
      <div className="title">
        {center.isNationalCenter && (
          <Image
            src={CenterIcon}
            alt="icon"
            className="icon"
            width={24}
            height={24}
          />
        )}
        <div>
          <Highlighter
            highlightClassName="YourHighlightClass"
            searchWords={[search]}
            autoEscape={true}
            textToHighlight={`${center.centerName}`}
          />
          <div className="text-sm font-work-sans">
            <Highlighter
              highlightClassName="YourHighlightClass"
              searchWords={[search]}
              autoEscape={true}
              textToHighlight={`${center.city || ''}${state ? `, ${state}` : ''}`}
            />
          </div>
        </div>
      </div>

      {center.centerMode === 'InPerson' && (
        <div className="info">
          <Image
            className="icon"
            src={LocationIcon}
            alt="location"
            width={24}
            height={24}
          />
          <Highlighter
            highlightClassName="YourHighlightClass"
            searchWords={[search]}
            autoEscape={true}
            textToHighlight={createCompleteAddress({
              streetAddress1: center.streetAddress1,
              streetAddress2: center.streetAddress2,
              city: center.city,
              zipCode,
              state,
            })}
          />
        </div>
      )}
      {phoneNumber && (
        <div className="info">
          <Image
            className="icon"
            src={CallIcon}
            alt="call"
            width={24}
            height={24}
          />
          <a href={`tel:+1${phoneNumber}`}>{phoneNumber}</a>
        </div>
      )}
      {center.email && (
        <div className="info email">
          <Image
            className="icon"
            src={EmailIcon}
            alt="email"
            width={24}
            height={24}
          />
          <a href={`mailto:${center.email}`} data-text={center.email}>
            {center.email}
          </a>
        </div>
      )}
      <div className="action-btn">
        <button className="submit-btn" onClick={goFindCourse}>
          Find Courses
        </button>
      </div>
    </div>
  );
};

export default CenterListItem;
